import React from 'react'
import API from '../Utils/api'
import { getUsuarioFromStorage } from '../Utils/usuarioHelper'
import Cleave from 'cleave.js/react'
import * as $ from 'jquery'
import * as yup from 'yup'
import SubMasterGerenciarClientes from "./SubMasterTemplate";
import { Link } from 'react-router-dom';


const initialFormValues = {
    form: {
        nome: '',
        telefone: '',
        cpf: ''
    }
}

const schema = yup.object().shape({
    nome: yup
        .string()
        .label('Nome')
        .required('Nome é obrigatório.')
        .trim(),
    telefone: yup
        .string()
        .label('Telefone')
        .required('Telefone é obrigatório.')
        .trim(),
    cpf: yup
        .string()
        .label('CPF')
        .required('CPF é obrigatório.')
        .trim()
})

export class MasterGerenciarClientes extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props)
        this.state = {
            user: JSON.parse(localStorage.getItem("user")),
            clientes: [],
            errors: [],
            form: {
                nome: '',
                telefone: '',
                cpf: ''
            },
            cleaves: {
                cpf: null,
                telefone: null
            },
            filteredList: []
            ,
            index: 1
        }
        this.deletaCliente = this.deletaCliente.bind(this)
    }

    componentDidMount() {
        this.listarClientes()
    }

    cpfInit = (cleave) => {
        this.setState(state => {
            return {
                ...state,
                cleaves: {
                    ...state.cleaves,
                    cpf: cleave
                }
            }
        })
    }

    telefoneInit = (cleave) => {
        this.setState(state => {
            return {
                ...state,
                cleaves: {
                    ...state.cleaves,
                    telefone: cleave
                }
            }
        })
    }

    listarClientes = async (e) => {
        try {
            const { user } = this.state
            const response = await API.post('/api/usuarios/listar-todos-clientes-a-partir', {

                index: this.state.index
            })

            this.setState({ clientes: response.data.sort(this.compararNome) })
            this.setState({ filteredList: this.state.clientes })
        } catch (err) {
            console.log(err)
        }
    }

    async listarClientes2(e) {
        try {
            const response = await API.post('/api/usuarios/listar-todos-clientes-l2', {
                spell: e.target.value
            })
            if (response) {
                this.setState({ clientes: response.data.sort(this.compararClientes) })
                this.setState({ filteredList: this.state.clientes })
            }
        } catch (err) {
            console.log(err)
        }
    }


    compararClientes(a, b) {
        if (a.nome > b.nome) {
            return 1;
        }
        if (a.nome < b.nome) {
            return -1;
        }

        return 0
    }


    handleRequiredCleaveLength = event => {
        const minLength = event.target.dataset.length
        const { name, rawValue } = event.target

        if (rawValue && rawValue.length < minLength) {
            this.setState(state => {
                return {
                    ...state,
                    form: {
                        ...state.form,
                        [name]: ''
                    }
                }
            })
            this.state.cleaves[name].setRawValue('')
        }
    }

    handleChangeCadastroRapido = event => {
        const { name, value } = event.target
        if (name) {
            this.setState(state => {
                return {
                    ...state,
                    form: {
                        ...state.form,
                        [name]: value
                    }
                }
            })
        }
    }

    resetForm = () => {
        this.setState({ form: { ...initialFormValues } })
        for (let key in this.state.cleaves) {
            this.state.cleaves[key].setRawValue('')
        }
    }

    hasFormError = (label = '') => {
        const errors = this.state.errors

        if (errors.length > 0) {
            const hasError = errors.filter(item => item.path === label)
            return hasError.length > 0
        }

        return false
    }

    getFormError = (label = '') => {
        const errors = this.state.errors

        if (errors.length > 0) {
            const hasError = errors.filter(item => item.path === label)
            return hasError
        }

        return []
    }

    cadastrarCliente = async () => {
        try {
            await schema.validate(this.state.form, { abortEarly: false })

            const dados = {
                ...this.state.form,
                tutorId: this.state.user._id
            }
            const response = await API.post('/api/usuarios/fast', dados)

            const { error } = response.data
            if (error) throw new Error(error)

            const update = this.state.clientes
            update.unshift(response.data)
            this.setState(state => {
                return {
                    ...state,
                    clientes: update,
                }
            })
            $('#modalCadastroRapido').modal('hide')

            setTimeout(() => alert('Usuário cadastrado com sucesso.'), 1000)

            this.resetForm()
        } catch (error) {
            if (error.name === 'ValidationError') {
                this.setState(state => {
                    return {
                        ...state,
                        errors: error.inner
                    }
                })
            } else {
                alert(error.message)
            }
        }
    }

    async deletaCliente(e) {
        try {
            const response = await API.post('/api/usuarios/deleta',
                {
                    id: e.target.name
                })
            alert("Cliente removido!")
            window.location.reload()
        } catch (err) {
            console.log(err)
        }

    }

    compararNome(a, b) {
        if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
            return 1;
        }
        if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
            return -1;
        }

        return 0
    }


    searchName(e) {
        var filteredList = this.state.clientes.filter(usuario => {
            if (usuario != undefined && usuario.nome.toLowerCase().includes(e.target.value.toLowerCase())) {
                return usuario;
            }
        }
        )

        this.setState({ filteredList: filteredList })
    }

    nextIndex() {

        this.setState({ index: this.state.index + 1, filteredList: [] })
        this.listarClientes()
    }
    prevIndex() {
        if (this.state.index > 0)
            this.setState({ index: this.state.index - 1, filteredList: [] })
        this.listarClientes()
    }
    render() {

        return (
            <SubMasterGerenciarClientes label="Gerenciar clientes">
                <div className="modal fade" id="modalCadastroRapido" tabIndex="-1" role="dialog"
                    aria-labelledby="modalCadastroRapidoTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header pb-3">
                                <h5 className="modal-title font-weight-bold" id="modalCadastroRapidoTitle">Cadastro
                                    rápido de clientes</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body"
                                style={{ borderTop: '1px solid #e9ecef', borderBottom: '1px solid #e9ecef' }}>
                                <form>
                                    <div className="form-row">
                                        <div className="form-group col">
                                            <input type="text" name="nome"
                                                className={`form-control ${this.hasFormError('nome') && 'is-invalid'}`}
                                                id="nome"
                                                placeholder="Nome completo"
                                                value={this.state.form.nome || ''}
                                                onChange={this.handleChangeCadastroRapido} />
                                            <div className="invalid-feedback">
                                                {this.getFormError('nome').map(item => item.message)}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-lg-6">
                                            <Cleave placeholder="CPF"
                                                id="cpf" name="cpf" data-length="11"
                                                onInit={this.cpfInit}
                                                className={`form-control ${this.hasFormError('cpf') && 'is-invalid'}`}
                                                options={{
                                                    numericOnly: true,
                                                    delimiters: ['.', '.', '-'],
                                                    blocks: [3, 3, 3, 2]
                                                }}
                                                value={this.state.form.cpf || ''}
                                                onChange={this.handleChangeCadastroRapido}
                                                onBlur={this.handleRequiredCleaveLength}
                                            />
                                            <div className="invalid-feedback">
                                                {this.getFormError('cpf').map(item => item.message)}
                                            </div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <Cleave name="telefone" type="tel"
                                                placeholder="Telefone"
                                                data-length="10"
                                                onInit={this.telefoneInit}
                                                className={`form-control ${this.hasFormError('telefone') && 'is-invalid'}`}
                                                options={{
                                                    phone: true,
                                                    phoneRegionCode: 'BR'
                                                }}
                                                value={this.state.form.telefone || ''}
                                                onChange={this.handleChangeCadastroRapido}
                                                onBlur={this.handleRequiredCleaveLength}
                                            />
                                            <div className="invalid-feedback">
                                                {this.getFormError('telefone').map(item => item.message)}
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer d-flex justify-content-end pt-3">
                                <button type="button" className="btn btn-fill btn-secondary mr-1"
                                    data-dismiss="modal">Cancelar
                                </button>
                                <button type="button" onClick={this.cadastrarCliente}
                                    className="btn btn-fill btn-success">Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <Link to="/monitoria-cadastros"
                                        className="btn btn-success btn-fill float-md-right float-lg-right">Cadastrar</Link>
                                    {/* <button type="button" title={'Cadastro rápido'}
                                        className="btn btn-primary btn-fill btn-icon float-md-right ml-1 mr-md-1"
                                        data-toggle="modal" onClick={this.resetForm}
                                        data-target="#modalCadastroRapido">
                                        <i className="fas fa-rocket"></i>
                                    </button> */}
                                    <h4 className="card-title">Acompanhe nossos clientes</h4>
                                    <p className="card-category">Informações dos clientes</p>
                                    {/* <span className="text-dark font-weight-bold">Total de clientes:</span> <span className="text-danger font-weight-bold"> {this.state.clientes.length}</span> */}
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <div className="row pl-5 pr-5 justify-content-center">
                                        {/* <input className="form-control w-50" placeholder="busca rapida..." onChange={this.searchName.bind(this)}></input> */}
                                        <input className="ml-5 w-50 form-control" placeholder="Filtrar a lista de clientes por nome" onChange={this.listarClientes2.bind(this)}></input>
                                    </div>
                                    <div className="mt-5 row justify-content-center">
                                        {/* <button className="btn-fill btn btn-danger" onClick={this.prevIndex.bind(this)}>⮜</button>                 
                                        <button className="btn-fill btn btn-danger ml-1" onClick={this.nextIndex.bind(this)}>⮞</button> */}
                                    </div>
                                    <table className="table table-hover table-striped">
                                        <thead>
                                            <tr>
                                                <th>Nome</th>
                                                <th>Rua</th>
                                                <th>Bairro</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.clientes && this.state.filteredList.map((item, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{item.nome}</td>
                                                        <td>{item.endereco}</td>
                                                        <td>{item.bairro}</td>
                                                        <td>{item.status ? 'Ativo' : 'Bloqueado'}</td>
                                                        <td className="w-100 d-flex justify-content-center">
                                                            <div className="dropdown">
                                                                <Link to="#" id={`dLabel_${index}`}
                                                                    type="button" data-toggle="dropdown"
                                                                    aria-haspopup="true"
                                                                    aria-expanded="false">
                                                                    <i className="fas fa-ellipsis-h"></i>
                                                                </Link>
                                                                <div className="dropdown-menu"
                                                                    aria-labelledby={`dLabel_${index}`}>
                                                                    <Link className="dropdown-item"
                                                                        to={`/monitoria-cadastros?id=${item._id}`}>Editar</Link>
                                                                    <Link to="#" className="dropdown-item" name={item._id}
                                                                    >Deletar
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                    <div className="row justify-content-center">
                                        {/* <button className="btn-fill btn btn-danger" onClick={this.prevIndex.bind(this)}>⮜</button>                 
                                        <button className="btn-fill btn btn-danger ml-1" onClick={this.nextIndex.bind(this)}>⮞</button> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </SubMasterGerenciarClientes>
        )
    }
}

export default MasterGerenciarClientes